export const runAsync = (runPromise: () => Promise<void>): void => {
    setTimeout(() => {
        runPromise().catch((err) => {
            console.error(err);
        });
    }, 0);
};
